import { createFileRoute } from '@tanstack/react-router';

import { ProviderApplicationsPage } from '@/features/services/provider/applications-page';

export const Route = createFileRoute('/_app/me/services/applications')({
  component: ProviderApplicationsPage,
});
